import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private readonly secretKey: string = environment.cryptedKey ?? '';

  generateKey(): string {
    const key = CryptoJS.lib.WordArray.random(32);
    return CryptoJS.enc.Base64.stringify(key);
  }

  /** Encrypt data with AES-256 + CBC + random IV */
  encryptAES256(data: any): string {
    const jsonString = JSON.stringify({ __data__: data });
    const key = CryptoJS.enc.Base64.parse(this.secretKey);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const encryptedData = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(encryptedData);
  }

  /** Decrypt data encrypted with AES-256 + CBC */
  decryptAES256(encryptedBase64: string | null): any {
    if (!encryptedBase64) return null;

    const encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64);

    const iv = CryptoJS.lib.WordArray.create(
      encryptedData.words.slice(0, 4),
      16
    );

    const ciphertext = CryptoJS.lib.WordArray.create(
      encryptedData.words.slice(4),
      encryptedData.sigBytes - 16
    );

    const key = CryptoJS.enc.Base64.parse(this.secretKey);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext } as CryptoJS.lib.CipherParams,
      key,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
    if (!jsonString) return null;

    const parsed = JSON.parse(jsonString);
    return parsed?.__data__ ?? null;
  }

}
